import { Box, Typography, useTheme } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

import Button from "@mui/material/Button";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { tokens } from "../../theme";

import Checkbox from "@mui/material/Checkbox";
import  TextTerm  from '../sign-term-text'

const IndexTerm = ({ handleConfirm, agree, handleCancel }) => {
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);
	const isNonMobile = useMediaQuery("(min-width: 800px)");
	const [open, setOpen] = useState(agree);
	const [scroll, setScroll] = useState("paper");
	const [checkedForm, setCheckedForm] = useState(false);

	const handleClickOpen = (scrollType) => () => {
		setOpen(true);
		setScroll(scrollType);
	};

	const handleCheckForm = () => {
		setCheckedForm(!checkedForm);
	};

	return (
		<Box>
			<Dialog
				open={!agree}
				scroll={scroll}
				aria-labelledby="scroll-dialog-title"
				aria-describedby="scroll-dialog-description"
			>
				<DialogTitle
					id="scroll-dialog-title"
					sx={{
						backgroundColor: "black",
						fontWeight: "bold"
					}}
				>
					TERMO DE COMPROMISSO E RESPONSABILIDADE
				</DialogTitle>
				<DialogContent
					dividers={scroll === "paper"}
					sx={{
						backgroundColor: colors.pink[900],
						"& .MuiTypography-root.MuiDialogContentText-root": {
							color: "whitesmoke !important"
						}
					}}
				>
					<DialogContentText
						id="scroll-dialog-description"
						// ref={descriptionElementRef}
						tabIndex={-1}
					>
						<div>
							<TextTerm />
							<Box
								mt="10px"
								ml="-10px"
								display="flex"
								alignItems="center"
								onClick={handleCheckForm}
								sx={{
									cursor: "pointer",
									backgroundColor: colors.pink[800],
									borderRadius: "10px"
								}}
							>
								<Checkbox
									color="secondary"
									checked={checkedForm}
									onChange={handleCheckForm}
								/>
								<Typography
									variant="h6"
									color={colors.greenAccent[500]}
                                    sx={{
                                        fontStyle: 'italic',
                                        fontWeight: "bold"
                                    }}
								>
									Estou de acordo com os termos propostos
								</Typography>
							</Box>
						</div>
					</DialogContentText>
				</DialogContent>
				<DialogActions
					sx={{
						backgroundColor: "black"
					}}
				>
					<Button
						onClick={handleCancel}
						sx={{
							color: colors.redAccent[500],
							fontWeight: "bold"
						}}
					>
						Cancelar
					</Button>
					<Button
						onClick={handleConfirm}
						sx={{
							color: colors.greenAccent[500],
							fontWeight: "bold"
						}}
						disabled={!checkedForm}
					>
						Confirmar
					</Button>
				</DialogActions>
			</Dialog>
		</Box>
	);
};

export default IndexTerm;
